/**
 * URL сервиса техподдержки (autochat). Берётся из env, по умолчанию — прод-хост.
 * Эндпоинт принимает multipart/form-data.
 */
export const SUPPORT_FORM_URL: string =
  process.env.REACT_APP_SUPPORT_FORM_URL ||
  'https://autochatprod-production.up.railway.app/pharmacy-support';

/**
 * Тип проблемы в выпадающем списке.
 * `label` совпадает с подписью и отправляется на бэк как `problem_type`.
 * `description` — подсказка для инфо-блока под селектом, в тикет не уходит.
 */
export interface ProblemType {
  label: string;
  description: string;
}

/**
 * Значения выпадающего списка «Тип проблемы» (вариант /pharmacy-support).
 */
export const PROBLEM_TYPES: readonly ProblemType[] = [
  {
    label: 'Проблема с личным кабинетом',
    description: 'Ошибка на сайте, зависание и т. п.',
  },
  {
    label: 'Проблема с заказом Wolt',
    description:
      'Техническая проблема (по вопросам отмены заказов обращайтесь в поддержку Wolt).',
  },
  {
    label: 'Проблема с заказом Glovo',
    description:
      'Техническая проблема (по вопросам отмены заказов обращайтесь в поддержку Glovo).',
  },
  {
    label: 'Не было уведомлений',
    description: 'Не было уведомлений о заказе, не было звука.',
  },
  {
    label: 'Не работают кнопки',
    description:
      '«Посадка в корзинку», «Заказ собран», «Сохранить», «Кто на смене».',
  },
  {
    label: 'Не пробивается чек',
    description: 'В Стандарт-Н, 1С, Рубус, ИнфоАптека и других программах.',
  },
  {
    label: 'Проблема с программой лояльности',
    description: 'Нет активного чека, не добавляется клиент и другие проблемы.',
  },
  {
    label: 'Нет заказа в корзинке',
    description: 'В Стандарт-Н, ИнфоАптека или собственной системе.',
  },
  {
    label: 'Другое',
    description: '',
  },
];

/**
 * Ключ в localStorage (внутри общего блоба `daribarAdminPanel`), которым
 * помечается переход по ссылке вида `https://apteka.daribar.kz/?tickets=true`.
 * Нужен потому, что query-параметр теряется по дороге: неавторизованного
 * пользователя `InitComponent` уводит на `/login` через `<Redirect to="/login" />`
 * (без search), а после входа `LoginPage` делает полную перезагрузку на `/orders`.
 */
export const SUPPORT_DEEP_LINK_KEY = 'supportTicketDeepLink';

/**
 * Время жизни метки перехода по ссылке — 30 минут. С запасом покрывает вход по
 * SMS-коду и при этом не даёт метке «залипнуть»: если ФЦ открыл ссылку и не стал
 * авторизовываться, следующий обычный вход в ЛК не должен открывать модалку.
 */
export const SUPPORT_DEEP_LINK_TTL_MS = 30 * 60 * 1000;
